<script>
import TenantServicesBase from "@/components/TenantServicesBase";
export default {
  extends: TenantServicesBase,
  data: () => ({
    configType: 'OrganisationPortal',
    apiSuffix: 'organisationportal',
    tenantDataKey: 'organisationportal_tenant',
    urlKey: 'organisationportal_url',
    generateUrlString: '.organisationportal.co.uk'

  }),
  methods: {
    getEnvType: function(type) {
      if (type === 'web') {
        return 11;
      }
    },
  },
  name: "tenant-organisationportal-service"
}
</script>
